module.exports = __webpack_public_path__ + "static/media/DJ.bfa16a92.jpg";